module.exports = __webpack_public_path__ + "img/patients-steps.60cf6915.png";